<template>
  <div class="row pt-3 px-md-5 mx-md-5 mx-1 mb-5 justify-content-center">
    <div class="col-12 text-center mt-3" v-if="mostrar_tiempo_restante">
        {{tiempo_restante_horas}} hrs.
      </div>
    <div class="col-12 mt-3 text-center">
      <h4>Terman</h4>
    </div>
    <div 
      :class="{
        'col-md-8':$route.params.serie==1 || $route.params.serie==5 || $route.params.serie==3 || $route.params.serie==7,
        'col-md-10':$route.params.serie==2 || $route.params.serie==4 || $route.params.serie==10,
      }"
      class="col-12 mt-5">
      <div v-bind:class="loading">
        <div class="d-flex justify-content-center">
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div v-bind:class="result">
        <div 
          v-if="
            $route.params.serie==1
            ||
            $route.params.serie==2
            ||
            $route.params.serie==7
            ||
            $route.params.serie==9
          "
          class="col-12 mt-3 border border-secondary">
          <div 
            class="row mb-3 justify-content-center"
            v-if="pregunta.active" 
            v-for="pregunta of examen.preguntas">
            <div
              v-if="$route.params.serie!=9" 
              class="col-12 mt-3 text-center pl-4">
              <b>{{pregunta.nompregunta}}</b>
            </div>
            <div class="col-12 my-2 ml-2">
              <div class="row justify-content-center">
                <div 
                  v-on:click="Seleccionar_Respuesta(pregunta.numero, respuesta.numero)"
                  class="select_respuesta text-center" 
                  :class="{
                    'col-md-2':$route.params.serie==9,
                    'col-md-3':$route.params.serie==1 || $route.params.serie==7 ,
                    'col-md-4':$route.params.serie==2
                  }"
                  v-for="respuesta of pregunta.respuestas">
                  <div class="row mt-3 justify-content-center">
                    <div class="col-2 text-right">
                      <i 
                        v-if="pregunta.respuesta===respuesta.numero" 
                        class="fas fa-sm fa-check" />
                      <i v-else class="far fa-sm fa-square"></i>
                    </div>
                    <div class="col-8 px-0 text-left">
                      {{respuesta.respuesta}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div 
          v-else-if="
            $route.params.serie==3
            ||
            $route.params.serie==6
            ||
            $route.params.serie==8
          "
          class="col-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Palabras</th>
                <th scope="col" class="text-center">
                  <span v-if="$route.params.serie==3">
                    Igual
                  </span>
                  <span v-if="$route.params.serie==6">
                    Si
                  </span>
                  <span v-if="$route.params.serie==8">
                    Verdadero
                  </span>
                </th>
                <th scope="col" class="text-center">
                  <span v-if="$route.params.serie==3">
                    Opuesto
                  </span>
                  <span v-if="$route.params.serie==6">
                    No
                  </span>
                  <span v-if="$route.params.serie==8">
                    Falso
                  </span>
                </th>
              </tr>
            </thead>
            <tbody v-for="pregunta of examen.preguntas" v-if="pregunta.active">
              <tr>
                <th scope="row">{{pregunta.numero}}</th>
                <td class="text-center">{{pregunta.nompregunta}}</td>
                <td 
                  v-on:click="Seleccionar_Respuesta(pregunta.numero,1)" 
                  class="text-center">
                  <i 
                    v-if="pregunta.respuesta==1" 
                    class="fas fa-check" />
                </td>
                <td 
                  v-on:click="Seleccionar_Respuesta(pregunta.numero,2)" 
                  class="text-center">
                  <i 
                    v-if="pregunta.respuesta==2" 
                    class="fas fa-check" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div 
          v-if="
            $route.params.serie==4
          "
          class="col-12 mt-3 border border-secondary">
          <div 
            class="row mb-3 justify-content-center"
            v-if="pregunta.active" 
            v-for="pregunta of examen.preguntas">
            <div 
              class="col-12 mt-3 text-center pl-4">
              <b>{{pregunta.nompregunta}}</b>
            </div>
            <div class="col-12 my-2 ml-2">
              <div class="row justify-content-center">
                <div
                  v-on:click="Seleccionar_Respuesta(pregunta.numero, respuesta.numero)"
                  class="col-2 select_respuesta text-center"
                  v-for="respuesta of pregunta.respuestas">
                  <div class="row mt-3 justify-content-center">
                    <div class="col-2 text-right">
                      <i 
                        v-if="pregunta.respuesta.indexOf(respuesta.numero)>=0" 
                        class="fas fa-sm fa-check" />
                      <i v-else class="far fa-sm fa-square"></i>
                    </div>
                    <div class="col-8 px-0 text-left">
                      {{respuesta.respuesta}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div 
          v-else-if="$route.params.serie==5 || $route.params.serie==10"
          class="col-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Pregunta</th>
                <th 
                  v-if="$route.params.serie==5" 
                  scope="col" 
                  class="text-center">
                  Respuesta
                </th>
                <th 
                  v-else
                  scope="col"
                  colspan="2" 
                  class="text-center">
                  Respuestas
                </th>
              </tr>
            </thead>
            <tbody v-for="pregunta of examen.preguntas" v-if="pregunta.active">
              <tr>
                <th scope="row">{{pregunta.numero}}</th>
                <td class="text-left">{{pregunta.nompregunta}}</td>
                <td class="text-center">
                  <div class="row">
                    <div class="form-group col-12">
                      <input
                        v-if="$route.params.serie==5" 
                        @keypress="validaNumericos($event)"
                        type="number"
                        v-model="pregunta.respuesta"
                        class="form-control">
                      <input
                        v-else
                        maxlength="6" 
                        type="text"
                        v-model="pregunta.respuesta"
                        class="form-control">
                    </div>
                  </div>
                </td>
                <td 
                  v-if="$route.params.serie==10"
                  class="text-center">
                  <div class="row">
                    <div class="form-group col-12">
                      <input 
                        maxlength="6" 
                        type="number"
                        v-model="pregunta.respuesta2"
                        class="form-control">
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-3">
            <button class="btn btn-success mr-3" v-if="pregunta_actual>1" v-on:click="Anterior_Pregunta">
              <i class="fas fa-arrow-circle-left"></i>
              Anterior
            </button>
            <button class="btn btn-success" :disabled="puedo_continuar==0" v-on:click="Continuar_Siguiente_Pregunta">
              Siguiente   
              <i class="fas fa-arrow-circle-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-5 text-center">
      <h5>Pregunta <b>{{pregunta_actual}}</b> / {{total_preguntas}}</h5>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      cantidad_siguiente:1,
      continuar_siguiente_pregunta_al_contestar:false,
      examen:{
        idexamen:null,
        abreviatura:"terman",
        nombre:"Terman",
        avance:70,
        preguntas:[]
      },
      pregunta_actual:1,
      avance:0,
      total_preguntas:0
    }
  },
  methods:{
    validaNumericos($event) {
      if (this.$route.params.serie==5) {
        if ($event.srcElement.value.length<4) {
          return true;
        }else{
          $event.preventDefault();        
        }
      }else if (this.$route.params.serie==10) {
        if ($event.srcElement.value.length<5) {
          return true;
        }else{
          $event.preventDefault();        
        }
      }
    },
    filterFloat(evt,input){
      var that = this;
      // Backspace = 8, Enter = 13, ‘0′ = 48, ‘9′ = 57, ‘.’ = 46, ‘-’ = 43
      var key = window.Event ? evt.which : evt.keyCode;    
      var chark = String.fromCharCode(key);
      var tempValue = input.value+chark;
      if(key >= 48 && key <= 57){
          if(that.filter(tempValue)=== false){
              return false;
          }else{       
              return true;
          }
      }else{
            if(key == 8 || key == 13 || key == 0) {     
                return true;              
            }else if(key == 46){
                  if(that.filter(tempValue)=== false){
                      return false;
                  }else{       
                      return true;
                  }
            }else{
                return false;
            }
      }
    },
    filter(__val__){
        var preg = /^([0-9]+\.?[0-9]{0,2})$/; 
        if(preg.test(__val__) === true){
            return true;
        }else{
           return false;
        }
        
    },
    restrictChars: function($event) {
      if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
          return true
      } else {
        $event.preventDefault();
      }
    },
    Buscar_Pregunta_Que_Se_Quedo(){
      var si_hay_contestadas=false;
      var i_contestada=null;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        this.examen.preguntas[i].active=false;
      }
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        this.examen.preguntas[i].active=false;
        if (this.$route.params.serie==4) {
          if (this.examen.preguntas[i].respuesta.length==2) {
            if (i>0) {
              this.examen.preguntas[i-1].active=false;
            }
            this.examen.preguntas[i].active=true;
            this.pregunta_actual=this.examen.preguntas[i].numero;
            i_contestada = i;
            si_hay_contestadas=true;
          }
        }
        else{
          if (this.examen.preguntas[i].respuesta!=null){
            if (i>0) {
              this.examen.preguntas[i-1].active=false;
            }
            this.examen.preguntas[i].active=true;
            this.pregunta_actual=this.examen.preguntas[i].numero;
            i_contestada = i;
            si_hay_contestadas=true;
          }
        }
      }
      if (!si_hay_contestadas) {this.examen.preguntas[0].active=true;}
    },
    Guardar_Avance(es_ultima){
      //solo enviar las respuestas de cada pregunta
      var preguntas=[];
      if (es_ultima) {console.log('Es ultima');this.Cargando();}
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.$route.params.serie==10) {
          preguntas.push({
            numero:this.examen.preguntas[i].numero,
            respuesta:this.examen.preguntas[i].respuesta,
            respuesta2:this.examen.preguntas[i].respuesta2
          });
        }else{
          preguntas.push({
            numero:this.examen.preguntas[i].numero,
            respuesta:this.examen.preguntas[i].respuesta
          });
        }
      }
      //post del avance
      this.$http.post('solicitudes/examen/avance',{
        tiempo_restante:this.tiempo_restante,
        avance:this.avance,
        idexamen:this.examen.idexamen,
        serie:this.$route.params.serie,
        preguntas:preguntas
      })
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        if (respuestaJson.resp=='Excelente') {
          if (es_ultima) {
            if (this.$route.params.serie>=10) {
              this.$router.push({
                name:'Examenes'
              });
            }else{
              this.$router.push({
                name:'terman_instrucciones',
                params:{
                  serie:Number(this.$route.params.serie)+1
                }
              });
            }
          }
        }else{
          swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
        }
      })
      .catch(error=>{
        swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
      });
    },
    Validar_Que_Esten_Contestadas_Todas_Las_Respuestas(){
      var that = this;
      var respuesta=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          if (this.$route.params.serie==4) {
            if (this.examen.preguntas[i].respuesta.length==2) {
              respuesta=true;
            }
          }
          else{
            if (this.examen.preguntas[i].respuesta!=null) {
              respuesta=true;
            }
          }
        }
      }
      if (respuesta && this.continuar_siguiente_pregunta_al_contestar) {
        setTimeout(function(){ 
          that.Cargando();
        }, 700);
        setTimeout(function(){ 
          that.Continuar_Siguiente_Pregunta();
        }, 900);
      }
    },
    Seleccionar_Respuesta(numero_pregunta,numero){
      var posicion=-1;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==numero_pregunta) {
          if (this.$route.params.serie==4) {
            posicion = this.examen.preguntas[i].respuesta.indexOf(numero);
            if(posicion>=0){
              this.examen.preguntas[i].respuesta.splice(posicion,1);
            }else{
              if (this.examen.preguntas[i].respuesta.length<2) {
                this.examen.preguntas[i].respuesta.push(numero);
              }
            }
          }else{
            if (this.examen.preguntas[i].respuesta==numero) {
              this.examen.preguntas[i].respuesta=null;
            }else{
              this.examen.preguntas[i].respuesta=numero;
            }
          }
        }
      }
      
      this.Validar_Que_Esten_Contestadas_Todas_Las_Respuestas();
    },
    Anterior_Pregunta(){
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        //if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=false;
        //}
      }
      this.pregunta_actual--;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=true;
        }
      }
    },
    Continuar_Siguiente_Pregunta(){  
      
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        //if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=false;
        //}
      }
      this.cantidad_siguiente++;
      var preguntasDeCadaExamen=[16,11,30,18,12,20,20,17,18,11];
      var total_preguntas_contestadas=0;
      var total_preguntas=173;
      for (var i = 1; i <= 10; i++) {
        if (i==this.$route.params.serie) {
          total_preguntas_contestadas=total_preguntas_contestadas+this.pregunta_actual;
          break;
        }else{
          total_preguntas_contestadas=total_preguntas_contestadas+preguntasDeCadaExamen[i-1];
        }
      }
      this.avance=(total_preguntas_contestadas*100)/total_preguntas;
      
      var continuar = true;
      if (this.pregunta_actual>=this.total_preguntas) {
        this.Guardar_Avance(true);
        continuar=false;
      }else if(this.cantidad_siguiente==5){
        this.cantidad_siguiente=1;
        this.Guardar_Avance();
      }
      if (continuar) {
        this.pregunta_actual++;
        for (var i = 0; i < this.examen.preguntas.length; i++) {
          if (this.examen.preguntas[i].numero==this.pregunta_actual) {
            this.examen.preguntas[i].active=true;
          }
        }
        this.Listo();
      }
    },
    Consultar_Preguntas(){
      this.Cargando();
      this.$http.get('solicitudes/mis/examenes/examen/terman/'+this.$route.params.serie)
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        if (respuestaJson.resp=='Excelente') {
          if (respuestaJson.examen.preguntas.length>0) {
            if (this.$route.params.serie==10) {
              for (var i = 0; i < respuestaJson.examen.preguntas.length; i++) {
                respuestaJson.examen.preguntas[i].respuesta=respuestaJson.examen.preguntas[i].respuesta1;
              }
            }
            this.examen=respuestaJson.examen;
            this.total_preguntas=respuestaJson.examen.preguntas.length;
            this.avance=respuestaJson.examen.avance;
            this.Buscar_Pregunta_Que_Se_Quedo();
          }else{
            swal("Favor de Recargar la Página", "Problemas para cargar las preguntas", "error");
          }
          
        }else{
          
          swal("¡Ups!",respuestaJson.resp, "error");  
        }
      })
      .catch(error=>{
        swal("Favor de Recargar la Página", "Problemas para cargar las preguntas", "error");
      })
      .finally(response=>{
        this.Listo();
      });

    },
    Cargando(){
      
      this.loading='';
      this.result='d-none';
    },
    Listo(){
      this.loading='d-none';
      this.result='';
    }
  },
  computed:{
    puedo_continuar(){
      var respuesta=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          if (this.$route.params.serie==4) {
            if (this.examen.preguntas[i].respuesta.length==2) {
              respuesta=true;
            }
          }
          else if (this.$route.params.serie==5 || this.$route.params.serie==10) {
            if (this.examen.preguntas[i].respuesta!=null) {
              if (this.examen.preguntas[i].respuesta.length>0) {
                if (this.$route.params.serie==10) {
                  if (this.examen.preguntas[i].respuesta2!=null) {
                    if (this.examen.preguntas[i].respuesta2.length>0) {
                      respuesta=true;
                    }
                  }   
                }else{
                  respuesta=true;
                }
              }
            }
          }
          else{
            if (this.examen.preguntas[i].respuesta!=null) {
              respuesta=true;
            }
          }
        }
      }
      
      if (respuesta) {
        return 1;
      }else{
        return 0;
      }
    },
    mostrar_tiempo_restante(){
      return this.$store.getters.getMostrar_Tiempo_Restante;
    },
    avance_total(){
      return this.$store.getters.getAvance_Total;
    },
    tiempo_restante(){
      return this.$store.getters.getTiempo_Restante;
    },
    tiempo_restante_horas(){
      return this.$store.getters.getTiempo_Restante_Horas;
    }
  },
  mounted(){
    this.Consultar_Preguntas();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Terman/Preguntas.vue